var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7354 3.86626L19.6419 7.28237C21.3624 10.3652 20.6718 14.4094 17.9619 17.1192C17.9619 17.1192 14.6754 20.4063 20.6345 26.3656C26.5917 32.3229 29.8808 29.0381 29.8808 29.0381C32.5907 26.3283 36.6347 25.6377 39.7176 27.3582L43.1336 29.2646C47.789 31.8626 48.3386 38.3909 44.247 42.4828C41.7883 44.9415 38.7762 46.8547 35.4465 46.9807C29.8415 47.1934 20.3225 45.7749 10.7739 36.2262C1.22532 26.6776 -0.193252 17.1586 0.0192467 11.5535C0.145471 8.22385 2.0586 5.21181 4.51732 2.75312C8.60911 -1.33868 15.1374 -0.788896 17.7354 3.86626Z",
    fill: "#3DC8AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.b9e60b3cf23dac32276b65fee701b98c.svg";
export { ForwardRef as ReactComponent };